import * as types from '../../constants/notification/notificationConstants';

export const notificationListRequest = () => ({
  type: types.NOTIFICATION_LIST_REQUEST,
});

export const setNotificationList = (list) => ({
  type: types.NOTIFICATION_LIST,
  list,
});

export const notificationReadRequest = (notificationNo) => ({
  type: types.NOTIFICATION_READ_REQUEST,
  notificationNo,
});

export const notificationRemoveRequest = (notificationNo) => ({
  type: types.NOTIFICATION_REMOVE_REQUEST,
  notificationNo,
});

export const createNotificationTokenRequest = (managerNo, token) => ({
  type: types.NOTIFICATION_TOKEN_CREATE_REQUEST,
  managerNo,
  token,
});

/**
 * Notification 반응 Action
 *
 * @param {number} resultCode 서버로부터 받은 결과 코드
 * @param {string} message 서버로부터 받은 결과 메시지
 * */
export const notificationResponse = (resultCode, message) => ({
  type: types.NOTIFICATION_RESPONSE_MESSAGE,
  resultCode,
  message,
});
